import type { Plan } from '@cel_cash/core/types'
import ApiService from '../api.service'

export type PlanoFixo = {
    limiteFuncionarios: number
    periodicity: Plan['periodicity']
    price: number
    /**
     * Identificador do plano no sistema legado
     * @deprecated Use `limiteFuncionarios` e `periodicity` para identificar o plano
     * @example '10-monthly'
     */
    legacyMyId?: string
}

export const planos = new ApiService<PlanoFixo>('planos')

export const faixaColaborador = new ApiService<number>(
    'planos/faixa-colaboradores',
)
